import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function NewSms({ color, fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Path
        d='
          M11.3701 1
          H2.29656
          C1.58022 1 1 1.58022 1 2.29656
          V8.77778
        '
        stroke={color}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='
          M9.16927 15.0026
          L10.4658 12.4103
          H13.7068
          C14.4224 12.4103 15.0026 11.8293 15.0026 11.1137
          V4.63249
          C15.0026 3.91616 14.4224 3.33594 13.706 3.33594
          H4.63249
          C3.91616 3.33594 3.33594 3.91616 3.33594 4.63249
          V11.1137
          C3.33594 11.8293 3.91616 12.4103 4.63249 12.4103
          H7.22483
        '
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M6.44531 6.44358H11.8898'
        stroke={color}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M6.44531 9.55295H9.55642'
        stroke={color}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

NewSms.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default NewSms
